import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import FormPage from "./formPage";
import DestinationPage from "./destinationPage";
import "../layout.css";
import "./formPage.css";
import {getUserInterest} from "../../apis/index";
import {graphql, useStaticQuery} from "gatsby";

const LayoutForm = ({children, pageDetail}) => {
  const DATA_NAME = process.env.GATSBY_ENV.includes('stg') ? 'pageDataStg' : 'pageData'
  let {
    type,
    singlePage,
    contentIndex,
    searchBar,
    gridName,
    cardClass,
    imageClass,
    buttonClass,
    buttonType,
    buttonNext,
    buttonBack,
    doneButton,
    before,
    completed,
    urlParam,
  } = pageDetail;

  let {example} = useStaticQuery(graphql`
      query {
          example {
              pageData {
                  Activity {
                      question
                      content {
                          color
                          imageUrl
                          text
                      }
                  }
                  BucketList {
                      question
                      content {
                          category
                          color
                          imageUrl
                          text
                          total
                      }
                  }
                  CheerUp {
                      content {
                          text
                      }
                  }
                  Reason {
                      content {
                          color
                          imageUrl
                          text
                      }
                      question
                  }
                  SinglePage1 {
                      introtext {
                        Activity
                        BucketList
                        Reason
                        Topic
                        TravelPreference
                        TravelledPlace
                      }
                      question {
                        Activity
                        BucketList
                        Reason
                        Topic
                        TravelPreference
                        TravelledPlace
                      }
                  }
                  Topic {
                      question
                      content {
                          color
                          imageUrl
                          text
                      }
                  }
                  TravelPreference {
                      content {
                          color
                          text
                          imageUrl
                      }
                      introtext
                      question
                  }
                  TravelledPlace {
                      content {
                          category
                          text
                          imageUrl
                          color
                          total
                      }
                      question
                  }
              },
              pageDataStg {
                  Activity {
                      question
                      content {
                          color
                          imageUrl
                          text
                      }
                  }
                  BucketList {
                      question
                      content {
                          category
                          color
                          imageUrl
                          text
                          total
                      }
                  }
                  CheerUp {
                      content {
                          text
                      }
                  }
                  Reason {
                      content {
                          color
                          imageUrl
                          text
                      }
                      question
                  }
                  SinglePage1 {
                      introtext {
                        Activity
                        BucketList
                        Reason
                        Topic
                        TravelPreference
                        TravelledPlace
                      }
                      question {
                        Activity
                        BucketList
                        Reason
                        Topic
                        TravelPreference
                        TravelledPlace
                      }
                  }
                  Topic {
                      question
                      content {
                          color
                          imageUrl
                          text
                      }
                  }
                  TravelPreference {
                      content {
                          color
                          text
                          imageUrl
                      }
                      introtext
                      question
                  }
                  TravelledPlace {
                      content {
                          category
                          text
                          imageUrl
                          color
                          total
                      }
                      question
                  }
              }
          }
      }
  `)


  let resultData = example[DATA_NAME];
  const [result, setResult] = useState();

  useEffect(() => {
    if (urlParam.ckel) {
      getUserInterest(encodeURIComponent(urlParam.ckel))
        .then(response => {
          const filledData = response[type]
          const newContent = resultData[type][contentIndex].content
          if (filledData) {
            for (let i = 0; i < filledData.length; i++) {
              const index = newContent.findIndex(
                con => con.text === filledData[i],
              );
              newContent[index].color = 'transparent'
            }
          }
          setResult(newContent)
        }).catch(err => {
        console.log("Error: ", err)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (type==='TravelledPlace' || type==='BucketList') {
    return (
        <>
          <DestinationPage
              type={type}
              singlePage={singlePage}
              contentIndex={contentIndex}
              searchBar={searchBar}
              gridName={gridName}
              cardClass={cardClass}
              imageClass={imageClass}
              buttonClass={buttonClass}
              buttonType={buttonType}
              buttonNext={buttonNext}
              buttonBack={buttonBack}
              resultData={resultData}
              doneButton={doneButton}
              before={before}
              completed={completed}
              urlParam={urlParam.ckel}
              result={result}
              cheerUpMessage={resultData.CheerUp}
          />
          <main>{children}</main>
        </>
    )
  }
  else {
    return (
        <>
          <FormPage
              type={type}
              singlePage={singlePage}
              contentIndex={contentIndex}
              searchBar={searchBar}
              gridName={gridName}
              cardClass={cardClass}
              imageClass={imageClass}
              buttonClass={buttonClass}
              buttonType={buttonType}
              buttonNext={buttonNext}
              buttonBack={buttonBack}
              resultData={resultData}
              doneButton={doneButton}
              before={before}
              completed={completed}
              urlParam={urlParam.ckel}
              result={result}
              cheerUpMessage={resultData.CheerUp}
          />
          <main>{children}</main>
        </>
    )
  }
}

LayoutForm.propTypes = {
  children: PropTypes.node.isRequired,
  pageDetail: PropTypes.object,
}

export default LayoutForm
